// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';

class OpeningHoursPeriod implements SimpleEntity {
    static fields: EntityFieldCollection = {
        open: {
            displayName: 'Open',
            recordName: 'open',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        close: {
            displayName: 'Close',
            recordName: 'close',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default OpeningHoursPeriod;
